import React from 'react';
import DispatchBaggage from '../../assets/icons/DispatchBaggage.svg';
import PersonalItemIcon from '../../assets/icons/PersonalItem.svg';
import HandBaggage from '../../assets/icons/HandBaggage_.svg';

import * as S from './styles';

function getBaggageText(type, value) {
  if (value === '1P') {
    if (type === 'dispatch') return '1 Bagagem despac.';
    if (type === 'hand') return '1 Bagagem de mão';
    if (type === 'personal') return '1 Item pessoal';
  }

  if (value === '2P') {
    if (type === 'dispatch') return '2 Bagagens despac.';
    if (type === 'hand') return '2 Bagagens de mão';
    if (type === 'personal') return '2 Itens pessoais';
  }

  return '';
}

function renderIcons(type, value) {
  if (value === '1P' || value === '2P') {
    if (type === 'dispatch') {
      return <img src={DispatchBaggage} alt='baggage' className='other-baggage' />;
    }
    if (type === 'hand') {
      return <img src={HandBaggage} alt='hand-baggage' className='hand-baggage' />;
    }

    if (type === 'personal') {
      return <img src={PersonalItemIcon} alt='personal-icon' className='personal-icon' />;
    }
  }
  
  return null;
}

function Baggage({ fareOption }) {
  if (!fareOption || !fareOption?.baggageallowance) {
    return null;
  }

  return (
    <S.Wrapper>
      <div className='baggage' style={{ display: 'flex', gap: 8, justifyContent: 'center' }}>
        {/* Bagagem despachada */}
        {fareOption.baggageallowance !== '0P' && fareOption.baggageallowance !== '' && (
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', marginTop: 4 }}>
            {renderIcons('dispatch', fareOption.baggageallowance)}
            <span style={{ marginTop: 4, fontSize: 8, width: '50px', textAlign: 'center' }}>{getBaggageText('dispatch', fareOption.baggageallowance)}</span>
          </div>
        )}
        {/* Bagagem de mão */}
        {fareOption.carryOnBaggage !== '0P' && fareOption.carryOnBaggage !== '' && (
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', marginTop: 4 }}>
            {renderIcons('hand', fareOption.carryOnBaggage)}
            <span style={{ marginTop: 4, fontSize: 8, width: '50px', textAlign: 'center' }}>{getBaggageText('hand', fareOption.carryOnBaggage)}</span>
          </div>
        )}
        {/* Item pessoal */}
        {fareOption.personalItemAllowance !== '0P' && fareOption.personalItemAllowance !== '' && (
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', marginTop: 4 }}>
            {renderIcons('personal', fareOption.personalItemAllowance)}
            <span style={{ marginTop: 4, fontSize: 8, width: '50px', textAlign: 'center' }}>{getBaggageText('personal', fareOption.personalItemAllowance)}</span>
          </div>
        )}
      </div>
    </S.Wrapper>
  );
}

export default Baggage;
